import * as actionTypes from "../actionTypes";

const initialState = {
    allData: [],
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_NEW_DENOMINATION:
            state = {
                ...state,
                allData: action.payload,
            };
            break;
        case actionTypes.ADD_NEW_DENOMINATION:
            state = {
                ...state,
                allData: [action.payload, ...state.allData],
            };
            break;
        case actionTypes.REMOVE_AN_DENOMINATION:
            state = {
                ...state,
                allData: state.allData.filter(
                    (denomination) => denomination.AMOUNT !== action.payload.AMOUNT
                ),
            };
            break;
        case actionTypes.UPDATE_QUANTITY_DENOMINATION:
            state = {
                ...state,
                allData: state.allData.map((denomination) => {
                    if (denomination.AMOUNT === action.payload.AMOUNT) {
                        const amount = Number(action.payload.AMOUNT) || 0;
                        const qty = Number(action.payload.QUANTITY) || 0;
                        const discount = Number(action.payload.DISCOUNT) || 0;

                        const total = qty > 0 ? amount - (amount * qty / 100) * discount : 0;


                        return {
                            ...denomination,
                            QUANTITY: qty,
                            TOTAL: total,
                        };
                    }
                    return denomination;
                }),
            };
            break;
        case actionTypes.WIPE_OUT_DENOMINATION:
            state = { allData: [] }
            break;
        default:
            state = { ...state };
    }
    return state;
};

export default reducer;
